module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAHzGGHvGGIaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABMALAAAAAAgACAAAAXA4CSOZGmeaCmtUuqiUiCvby3Gct7aKZ7rvJNPh9sFb78ZK0A7DpVLVvDJZOEajuaLah1mm4JekgXhsgRh2E/ypc4Wq7SwuPgmk4uGVgh1Jx9SYlV3hFV7Jn6FYy4sEYo/dkyMKw+PARCRkj1LhQUFEhGOQJsrhASfEno/E0ZzEgZJCgosDausWysIOQMJtEk3LwIrDDESAywHhLcpaMKllA+1hK24hn7UNYmjR6yP2FOF304yIjPcMCTi56yB6+4hADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSE_S2.gif
// module id = jyTB
// module chunks = 48